/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Organization1Inputs */

const en_navtitles_organization1 = /** @type {(inputs: Navtitles_Organization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ORGANIZATION`)
};

/**
* | output |
* | --- |
* | "ORGANIZATION" |
*
* @param {Navtitles_Organization1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_organization1 = /** @type {((inputs?: Navtitles_Organization1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Organization1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_organization1(inputs)
});
export { navtitles_organization1 as "navTitles_organization" }